import { Headline3 } from 'aimo-ui';
import VehicleColorSelector from 'components/account/vehicle/VehicleColorSelector';
import VehicleIconSelector from 'components/account/vehicle/VehicleIconSelector';
import VehicleNameInput from 'components/account/vehicle/VehicleNameInput';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useVehicleStore } from 'stores/vehicleStore';
import { StyledWrapper } from 'styles/ContainerStyles';

const VehicleFormExtras = () => {
  const { vehicleData, setVehicleData } = useVehicleStore((state) => state);
  const { appSettings, name, id } = vehicleData ?? {};
  const { color, icon } = appSettings ?? {};
  const { t } = useTranslation();

  return (
    <>
      {!id && (
        <StyledWrapper mb={20}>
          <Headline3>{t('vehicle.form.optionalDetails')}</Headline3>
        </StyledWrapper>
      )}
      <StyledWrapper mb={20}>
        <VehicleNameInput name={name ?? ''} setName={setVehicleData} />
      </StyledWrapper>
      <StyledWrapper mb={20}>
        <VehicleColorSelector
          selectedColor={color ?? ''}
          setSelectedColor={setVehicleData}
        />
      </StyledWrapper>
      <StyledWrapper mb={20}>
        <VehicleIconSelector
          selectedIcon={icon ?? ''}
          setSelectedIcon={setVehicleData}
        />
      </StyledWrapper>
    </>
  );
};

export default VehicleFormExtras;
